module.exports = __webpack_public_path__ + "static/media/handle-blue.6531b473.png";